export enum HistoryLocation {
    PENDING = 1,
    CLASSIFIED = 2,
}